const clientRoutePath = {
    BASE_PATH: "/",
    ADMIN: {
        BASE_PATH: "admin",
        DASHBOARD_PAGE: "/dashboard",
        PROFILE_PAGE: "/profile",
        USER_PAGE: "/user",
        COORDINATOR_REQUEST_PAGE: "/coordinator-request",
        MY_COMPANY_PAGE: "/my-company",
        PARTNERSHIP_COMPANY_PAGE: "/partnership-company",
        REQUEST_PARTNERSHIP_COMPANY_PAGE: "/partnership-company-request",
        CREATE_PARTNERSHIP_COMPANY_PAGE_REQUEST:
            "/partnership-company-request/create",
        COMPANY_PAGE: "/company",
        MY_SCHOOL_PAGE: "/my-school",
        PARTNERSHIP_SCHOOL_PAGE: "/partnership-school",
        REQUEST_PARTNERSHIP_SCHOOL_PAGE: "/partnership-school-request",
        SCHOOL_PAGE: "/school",
        CATEGORY_PAGE: "/category",
        SERVICEGROUP_PAGE: "/company/:id/service-group",
        COMPANYDOCUMENT_PAGE: "/company/:id/company-document",
        TYPOLOGY_PAGE: "/typology",
        INTERNSHIP_PAGE: "/internship",
        INTERNSHIP_SCHEDULE_PAGE: "/internship/:id/schedule",
        INTERNSHIP_SCHEDULE_SEAT_PAGE:
            "/internship/:id/schedule/:internshipScheduleId/seat",
        INTERNSHIP_SCHEDULE_SKILL_PAGE:
            "/internship/:id/schedule/:internshipScheduleId/skill",
        MY_INTERNSHIP_PAGE: "/my-internship",
        FIND_INTERNSHIP_COMPANY_PAGE: "/find-internship-company",
        FIND_INTERNSHIP_SCHOOL_PAGE: "/find-internship-school",
        STUDENT_PAGE: "/my-internship/:internshipScheduleSeatId/student",
        STUDENTS_PAGE: "/my-internship/:internshipScheduleSeatId/students",
        INTERNSHIP_SCHEDULE_STUDENT_PAGE:
            "/internship/:id/schedule/:internshipScheduleId/student",
        STUDENT_SKILL_PAGE: "/my-internship/:internshipScheduleSeatId/skill",
        STUDENTS_SKILL_PAGE:
            "/my-internship/:internshipScheduleSeatId/student/:studentId/skill",
        INTERNSHIP_SCHEDULE_STUDENT_SKILL_PAGE:
            "/internship/:id/schedule/:internshipScheduleId/student/:studentId/skill",
        REGION_PAGE: "/region",
        SKILL_PAGE: "/skill",
        SKILL_CRITERIA_PAGE: "/skill/:id/skill-criteria",
        TRAINING_PAGE: "/training",
        GESTURE_PAGE: "/gesture",
        SCHOOL_BATCH_PAGE: "/school-batch",
        TIMESHEET_TYPE_PAGE: "/timesheet-type",
        TIMESHEET_PAGE: "/my-internship/:internshipScheduleSeatId/timesheet",
        INTERNSHIP_TIMESHEET_PAGE:
            "/internship/:id/schedule/:internshipScheduleId/timesheet",
        MESSAGE_PAGE: "/message",
        MESSAGES_PAGE: "/messages",
        LOGOUT: "/logout",
    },
    PUBLIC: {
        BASE_PATH: "",
        SECURITY: {
            LOGIN_PAGE: "",
            TOKEN_LOGIN_PAGE: "tl/:token",
            FORGOT_PASSWORD_PAGE: "forgot-password",
            SET_PASSWORD_PAGE: "set-password/:code",
        },
    },
};

export const cPath = (
    key: string,
    params?: { [key: string]: string | number | null | undefined },
    isFixed: boolean = false
): string => {
    const keyChunks = key.split(".");
    let tv = clientRoutePath;
    let path = clientRoutePath["BASE_PATH"];
    keyChunks?.map((value) => {
        if (!value) {
            return;
        }
        if (typeof tv[value] === "string") {
            if (isFixed) {
                path = tv[value].startsWith("/")
                    ? tv[value].substr(1)
                    : tv[value];
            } else {
                path += tv[value];
            }
        }
        tv = tv[value];
        if (typeof tv[value] !== "string" && tv["BASE_PATH"] !== undefined) {
            path += tv["BASE_PATH"];
        }
    });
    if (params) {
        Object.keys(params)?.map(
            (value) => (path = path.replace(`/:${value}`, `/${params[value]}`))
        );
    }
    return path;
};

const matchRoute = (route: string, path: string): boolean => {
    const pattern = route.replace(/:[^/]+/g, "[^/]+").replace(/\//g, "\\/");
    const regex = new RegExp(`^${pattern}$`);
    return regex.test(path);
};

export const isRouteMatch = (key: string, url: string): boolean => {
    const route = cPath(key);
    return matchRoute(route, url);
};
